import React from 'react';
import AttachmentItem from './AttachmentItem';

const AttachmentList = ({ attachments, messageId, isSent }) => {
    if (!attachments || attachments.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2 mt-2">
            {attachments.map((attachment, index) => (
                <AttachmentItem
                    key={attachment.attachmentId || `${messageId}-${index}`}
                    attachment={attachment}
                    messageId={messageId}
                    isSent={isSent}
                />
            ))}
        </div>
    );
};

export default AttachmentList;